import { render, staticRenderFns } from "./UploadModals.vue?vue&type=template&id=417e0054"
import script from "./UploadModals.vue?vue&type=script&lang=js"
export * from "./UploadModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports